/// <amd-module name="Core/Medius.Core.Web/Scripts/Bifrost/embedding"/>

export const getEmbeddableUrlIfNeeded = (prefix: string) => {
    const currentUrl = window.location.href;
    const cleanPrefix = prefix.replace(/^#?\/?/, "");
    
    if (currentUrl.includes("SupplierInvoicesInboxLegacy")) {
        return "SupplierInvoicesInboxLegacy#/" + cleanPrefix;
    }
    else if (currentUrl.includes("SupplierInvoicesInbox")){
        return "SupplierInvoicesInbox#/" + cleanPrefix;
    }

    return prefix;
};
